<template>
	<component
		:is="componentName"
		v-if="block && hasComponent(componentName)"
		:block="block"
		:fetched-data="fetchedData"
	/>
</template>

<script>
import panel from '~/mixins/panel';
import hasComponent from '~/utils/hasComponent';
import Default from '~/components/panels/PanelMedia/PanelDefault.vue';
import PanelReview from '~/components/panels/PanelMedia/PanelReview.vue';

export default {
	name: 'PanelMedia',
	components: {
		PanelReview,
		Default,
	},
	mixins: [panel],
	computed: {
		componentName() {
			return this.block.media_appearance;
		},
	},
	methods: {
		hasComponent,
	},
};
</script>
